import { UserNotificationUtilService, UserNotification } from "@scisys-uim/uim-common";
import { ASSET_TYPE, FIREARM_TYPE, TRANSFER_ASSET_TYPE } from "assets-model";

export class AssetMaintenanceNotificationUtilService implements UserNotificationUtilService {

  unableToDismissReason(notification?: UserNotification): string {
    return ""
  }

  canBeDismissed(notification: UserNotification): boolean {
    return false;
  }

  getUserMessageType(): string {
    return "AssetMaintenanceAction";
  }

  getRouteFromLinkData(notification: UserNotification): any[] {
    if (notification.linkData.isAssetUser) {
      return [...ASSET_TYPE.searchRouteBase];
    } else {
      return [...FIREARM_TYPE.searchRouteBase];
    }
  }

  getRouteLinkQueryParams(notification: UserNotification) {
    return {
      routineMaintenanceDueSoon: notification.linkData.routineMaintenanceDueSoon
    }
  }

}
